export enum SeatMapType {
  AisleSeat = 'A',
  CenterSeat = '9',
  NoSeat = 'NS',
  AisleSeatDes = 'AisleSeat'
}
